export default function numberToLocalString(number: Number) {
  return number.toLocaleString(navigator.languages[0] ?? navigator.languages)
}